<p-dialog [header]="lastNotification?.title || ''" [modal]="true" [(visible)]="notificationModalVisible">
    <h1 class="mb-8 text-lg" [ngClass]="{'text-red-500': lastNotification?.type === 'error'}">
        {{lastNotification?.message || ''}}
    </h1>
    <div class="flex justify-end">
        <p-button label="Затвори" (click)="onCloseModal()" severity="secondary" styleClass="!w-full h-full"></p-button>
    </div>
</p-dialog>